__turbopack_context__.v({
  "appear-slide-left": "ServiceItem-module-scss-module__8xXDYa__appear-slide-left",
  "bounceTwice": "ServiceItem-module-scss-module__8xXDYa__bounceTwice",
  "even": "ServiceItem-module-scss-module__8xXDYa__even",
  "fade-in-bottom": "ServiceItem-module-scss-module__8xXDYa__fade-in-bottom",
  "fade-in-left": "ServiceItem-module-scss-module__8xXDYa__fade-in-left",
  "fade-in-right": "ServiceItem-module-scss-module__8xXDYa__fade-in-right",
  "fadeIn": "ServiceItem-module-scss-module__8xXDYa__fadeIn",
  "flexContainer": "ServiceItem-module-scss-module__8xXDYa__flexContainer",
  "item": "ServiceItem-module-scss-module__8xXDYa__item",
  "loader": "ServiceItem-module-scss-module__8xXDYa__loader",
  "photo": "ServiceItem-module-scss-module__8xXDYa__photo",
  "puff-in-center": "ServiceItem-module-scss-module__8xXDYa__puff-in-center",
  "puff-in-left": "ServiceItem-module-scss-module__8xXDYa__puff-in-left",
  "pulse": "ServiceItem-module-scss-module__8xXDYa__pulse",
  "pulse-contact": "ServiceItem-module-scss-module__8xXDYa__pulse-contact",
  "shake-bottom": "ServiceItem-module-scss-module__8xXDYa__shake-bottom",
  "slide-again": "ServiceItem-module-scss-module__8xXDYa__slide-again",
  "slide-in-right": "ServiceItem-module-scss-module__8xXDYa__slide-in-right",
  "stepContent-entrance": "ServiceItem-module-scss-module__8xXDYa__stepContent-entrance",
  "text": "ServiceItem-module-scss-module__8xXDYa__text",
  "title": "ServiceItem-module-scss-module__8xXDYa__title",
});
